'use client';

import { useConfig } from '@/app/contexts/ConfigContext';
import { checkUrlCountry } from '@/helpers';
import { LANGUAGE_OPTIONS } from '@/helpers/enums';

export default function TermsSpecificToNO() {
  const { config } = useConfig();

  return (
    <>
      {checkUrlCountry(
        config.SERVICE_URL_LINK,
        LANGUAGE_OPTIONS.NO,
      ) && (
        <div style={{ color: config.theme.textColorDark }}>
          <p className='mb-4' style={{ color: config.theme.textColorDark }}>
            Minimumsalderen for å få tilgang til denne tjenesten er 18 år.
            {/* L'âge minimum pour accéder à ce service est 18 ans */}
          </p>
        </div>
      )}
    </>
  );
}
